import React from 'react';
import { Icons } from 'components';
import { Typography, Grid, Chip, InputLabel } from '@mui/material';
import { useStyles } from './Style';

/**
 * توی صفحه مدارک ،  به ازای هر باکس مدرک این کامپوننت میباشد
 */
const FileBoxItem = ({ data, onOpenUploadDialog = () => {} }) => {
  const classes = useStyles();

  const { label, level, content } = data;
  return (
    <>
      <div className={classes.titleBox}>
        {level + 1 + '.' + (level !== 6 ? label : 'بارگذاری سایر مدارک (اختیاری)')}
        <InputLabel shrink className={classes.label} style={{ display: 'flex' }}>
          {level === 4 && (
            <span style={{ color: '#ef5350', margin: '0px 8px 0 8px', fontSize: '19px' }}>*</span>
          )}
        </InputLabel>
      </div>
      <Grid className={classes.chipBlock}>
        <Chip
          className={classes.chips}
          key={1}
          label={
            content.fileUploaded.length > 0 ? (
              <>
                <div className={classes.fileType}>
                  <Icons icon="EmptyFile" color="#CED4D9" size="42" />
                  <div className={classes.typeFile} style={{ background: '#607D8B' }}>
                    file
                  </div>
                </div>
                <Typography>{content.fileUploaded.length + ' فایل بارگذاری شده '}</Typography>
              </>
            ) : (
              <>
                <div className={classes.uploadIcon}>
                  <Icons icon="Upload" color="#667585" hover="#667585" size="20" />
                </div>
                <Typography
                  className={classes.titleNotFile}
                  onClick={() => {
                    onOpenUploadDialog(level, 'ADD');
                  }}
                >
                  برای آپلود کلیک کنید
                </Typography>
              </>
            )
          }
          onDelete={() => {
            onOpenUploadDialog(level, 'EDIT');
          }}
          deleteIcon={
            content.fileUploaded.length > 0 ? (
              <div>
                <Icons icon="Edit" color="#667585" hover="#D92D20" size="20" />
              </div>
            ) : (
              <></>
            )
          }
        />
      </Grid>
    </>
  );
};

export default FileBoxItem;
